import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useShop } from '../context/ShopContext';
import { 
  Crown, 
  Sparkles, 
  ShieldCheck, 
  CheckCircle2, 
  Building2, 
  Phone, 
  MapPin, 
  CreditCard,
  ArrowRight,
  LogOut,
  TrendingDown,
  Calculator,
  FileText
} from 'lucide-react';

export default function B2BClubPage() {
  const { 
    b2bMember, 
    setB2bMember, 
    logoutB2B,
    addToast 
  } = useShop();

  const [form, setForm] = useState({
    businessName: '',
    ownerName: '',
    phone: '',
    gstNumber: '',
    city: '',
    categoryInterest: 'All Gold Jewellery (22K/18K)'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.ownerName.trim() || !form.phone.trim()) {
      addToast('Please enter your name and phone number', 'error');
      return;
    }

    const memberData = {
      id: '24K-' + Math.floor(100000 + Math.random() * 900000),
      businessName: form.businessName.trim() || form.ownerName.trim(),
      ownerName: form.ownerName.trim(),
      phone: form.phone.trim(),
      gstNumber: form.gstNumber.trim().toUpperCase(),
      city: form.city.trim() || 'India',
      categoryInterest: form.categoryInterest,
      joinedAt: new Date().toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }),
      membershipTier: form.gstNumber ? 'B2B Certified Partner' : 'Trade Partner Member',
      discountedWastageUnlocked: true
    };

    setB2bMember(memberData);
    addToast(`Welcome ${memberData.ownerName}! B2B Wholesale Trade Rates Unlocked!`, 'success');
  };

  return (
    <div style={{ minHeight: '80vh', backgroundColor: '#07070b', color: '#fff', padding: '2rem 1rem 5rem' }}>
      <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
        {/* Breadcrumb Navigation */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '1.75rem' }}>
          <Link to="/" style={{ color: 'var(--gold-400)', textDecoration: 'none' }}>Home</Link>
          <span>/</span>
          <span style={{ color: '#fff' }}>B2B Wholesale & Trade Partner Portal</span>
        </div>

        {b2bMember ? (
          /* Logged In Member Dashboard */
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{
              background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, #0c0c14 100%)',
              borderRadius: '24px',
              border: '1px solid var(--border-gold)',
              padding: '2.5rem',
              boxShadow: '0 20px 50px rgba(0,0,0,0.6)',
              marginBottom: '2rem'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(212, 175, 55, 0.15)',
                    border: '2px solid var(--gold-400)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Crown size={32} color="var(--gold-400)" />
                  </div>
                  <div>
                    <span style={{
                      display: 'inline-block',
                      backgroundColor: 'rgba(52, 211, 153, 0.15)',
                      color: '#34d399',
                      fontSize: '0.75rem',
                      fontWeight: 700,
                      padding: '3px 10px',
                      borderRadius: '999px',
                      marginBottom: '0.3rem'
                    }}>
                      ✓ {b2bMember.membershipTier} Active
                    </span>
                    <h1 style={{ fontSize: '1.8rem', fontWeight: 800, color: '#fff', margin: 0 }}>
                      {b2bMember.businessName}
                    </h1>
                    <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
                      Managed by {b2bMember.ownerName} • Member ID: {b2bMember.id}
                    </div>
                  </div>
                </div>

                <button
                  onClick={logoutB2B}
                  className="btn btn-secondary btn-sm"
                  style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: '#f87171' }}
                >
                  <LogOut size={14} /> Exit Portal
                </button>
              </div>

              {/* Benefits status */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1rem',
                backgroundColor: '#12121e',
                borderRadius: '16px',
                padding: '1.5rem',
                border: '1px solid rgba(212, 175, 55, 0.2)',
                marginBottom: '2rem'
              }}>
                <div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Wastage Tier Status</div>
                  <div style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--gold-400)', marginTop: '2px' }}>
                    VIP 5.99% Wholesale Unlocked
                  </div>
                </div>
                <div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Registered City</div>
                  <div style={{ fontSize: '1.1rem', fontWeight: 700, color: '#fff', marginTop: '2px' }}>
                    {b2bMember.city}
                  </div>
                </div>
                <div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>GST Verification</div>
                  <div style={{ fontSize: '1.1rem', fontWeight: 700, color: '#34d399', marginTop: '2px' }}>
                    {b2bMember.gstNumber || 'Exempt / Club Pass'}
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <Link to="/category/all" className="btn btn-gold" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Sparkles size={16} /> Browse Wholesale Catalog
                </Link>
              </div>
            </div>
          </div>
        ) : (
          /* Registration Form View */
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '2.5rem', alignItems: 'start' }}>
            {/* Left Column: Benefits */}
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '4px 12px', borderRadius: '999px', backgroundColor: 'rgba(212, 175, 55, 0.15)', border: '1px solid var(--gold-400)', color: 'var(--gold-400)', fontSize: '0.78rem', fontWeight: 700, marginBottom: '1rem' }}>
                <Crown size={14} /> B2B Trade Partner Portal
              </div>
              <h1 style={{ fontSize: '2.2rem', fontWeight: 800, color: '#fff', marginBottom: '1rem', lineHeight: 1.2 }}>
                Join B2B Trade Portal for Direct Wholesale Rates
              </h1>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '2rem' }}>
                Whether you are a retailer, wedding planner, jewellery connoisseur, or corporate buyer, enrolling grants you immediate access to our lowest manufacturing rates and priority production slots.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: 'rgba(212, 175, 55, 0.1)', border: '1px solid var(--border-gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <TrendingDown size={20} color="var(--gold-400)" />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#fff', marginBottom: '0.2rem' }}>
                      Direct Manufacturer Pricing
                    </h3>
                    <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
                      Save up to ₹25,000 on heavy bridal necklaces and bangles compared to retail showrooms.
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: 'rgba(212, 175, 55, 0.1)', border: '1px solid var(--border-gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <ShieldCheck size={20} color="var(--gold-400)" />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#fff', marginBottom: '0.2rem' }}>
                      100% BIS Hallmarked & HUID Certified
                    </h3>
                    <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
                      Every piece has government laser hallmarks verifiable on the BIS Care portal.
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: 'rgba(212, 175, 55, 0.1)', border: '1px solid var(--border-gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Building2 size={20} color="var(--gold-400)" />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#fff', marginBottom: '0.2rem' }}>
                      Insured Armored Logistics Pan-India
                    </h3>
                    <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
                      Fully insured dispatch to 19,000+ PIN codes with tamper-evident sealed packaging.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Registration Form */}
            <div style={{
              backgroundColor: '#0c0c14',
              borderRadius: '20px',
              border: '1px solid var(--border-gold)',
              padding: '2.5rem 2rem',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.6)'
            }}>
              <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#fff', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Crown size={20} color="var(--gold-400)" /> Free B2B Trade Partner Enrollment
              </h2>
              <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '1.75rem' }}>
                Zero membership fees. Instant activation for exclusive pricing.
              </p>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
                    Full Name / Owner Name *
                  </label>
                  <input 
                    type="text" 
                    required
                    placeholder="e.g. Ramesh Chandra Verma"
                    value={form.ownerName}
                    onChange={(e) => setForm({ ...form, ownerName: e.target.value })}
                    style={{
                      width: '100%',
                      backgroundColor: '#12121e',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '8px',
                      padding: '0.65rem 0.9rem',
                      color: '#fff',
                      fontSize: '0.9rem'
                    }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
                    Business Name (Optional)
                  </label>
                  <input 
                    type="text" 
                    placeholder="e.g. Verma Jewellers or Personal"
                    value={form.businessName}
                    onChange={(e) => setForm({ ...form, businessName: e.target.value })}
                    style={{
                      width: '100%',
                      backgroundColor: '#12121e',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '8px',
                      padding: '0.65rem 0.9rem',
                      color: '#fff',
                      fontSize: '0.9rem'
                    }}
                  />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
                      Phone / WhatsApp *
                    </label>
                    <input 
                      type="tel" 
                      required
                      placeholder="e.g. 98765 43210"
                      value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      style={{
                        width: '100%',
                        backgroundColor: '#12121e',
                        border: '1px solid rgba(212, 175, 55, 0.3)',
                        borderRadius: '8px',
                        padding: '0.65rem 0.9rem',
                        color: '#fff',
                        fontSize: '0.9rem'
                      }}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
                      City / State *
                    </label>
                    <input 
                      type="text" 
                      required
                      placeholder="e.g. Jaipur, Rajasthan"
                      value={form.city}
                      onChange={(e) => setForm({ ...form, city: e.target.value })}
                      style={{
                        width: '100%',
                        backgroundColor: '#12121e',
                        border: '1px solid rgba(212, 175, 55, 0.3)',
                        borderRadius: '8px',
                        padding: '0.65rem 0.9rem',
                        color: '#fff',
                        fontSize: '0.9rem'
                      }}
                    />
                  </div>
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
                    GSTIN Number (Optional - for B2B Input Tax Credit)
                  </label>
                  <input 
                    type="text" 
                    placeholder="22AAAAA0000A1Z5"
                    value={form.gstNumber}
                    onChange={(e) => setForm({ ...form, gstNumber: e.target.value.toUpperCase() })}
                    style={{
                      width: '100%',
                      backgroundColor: '#12121e',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '8px',
                      padding: '0.65rem 0.9rem',
                      color: '#fff',
                      fontSize: '0.9rem'
                    }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.4rem' }}>
                    Primary Jewellery Requirement:
                  </label>
                  <select
                    value={form.categoryInterest}
                    onChange={(e) => setForm({ ...form, categoryInterest: e.target.value })}
                    style={{
                      width: '100%',
                      backgroundColor: '#12121e',
                      border: '1px solid rgba(212, 175, 55, 0.3)',
                      borderRadius: '8px',
                      padding: '0.65rem 0.9rem',
                      color: '#fff',
                      fontSize: '0.9rem'
                    }}
                  >
                    <option value="All Gold Jewellery (22K/18K)">All Gold Jewellery (22K/18K)</option>
                    <option value="Bridal Chokers & Polki Sets">Bridal Chokers & Polki Sets</option>
                    <option value="Solid Bangles & Kadas">Solid Bangles & Kadas</option>
                    <option value="Diamond Solitaires & Rings">Diamond Solitaires & Rings</option>
                    <option value="Luxury Kitchenware & Cookware">Luxury Kitchenware & Cookware</option>
                  </select>
                </div>

                <button
                  type="submit"
                  className="btn btn-gold"
                  style={{
                    width: '100%',
                    padding: '0.85rem',
                    fontSize: '1rem',
                    fontWeight: 700,
                    marginTop: '0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}
                >
                  <Crown size={18} /> Activate B2B Trade Membership
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
